import { render } from "./Epg.vue?vue&type=template&id=0ef2ef03"
import script from "./Epg.vue?vue&type=script&lang=js"
export * from "./Epg.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\webtv\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__